import config from 'config';
import { $axios, urls } from './http-client';

export const fetchChannels = () => {
  if (config.useMock) {
    return Promise.resolve([]);
  }
  return $axios.get(`${urls.voicetube}/v2.2/channels`, {
    params: { language: 'zh-TW', platform: 'Web' },
  }).then((res) => res.data.data.items);
};

export const sendFeedback = (data) => $axios.post(`${urls.voicetube}/v2.1/zh-TW/feedback`, data);
